module.exports = __webpack_public_path__ + "assets/img/banner.d8da95cf.jpg";